//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmSpisovyZnakDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.15.2
//AdtGeneratorConfig:[ T:(sslsspz) GID:(Web.Set.Des.Ts) V1:(spis_pl,spis_znak,lic,aktivita,arw,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,nazev,skar_znak,skar_lhuta,popis,cs2_spis_znak,skar_lhuta_spra,priz_zded,typ_spis_z,spis_znak_ext,priz_usr,spis_znak_nad,num_pod,spis_znak_norm,prirustek,priz_trvskar,spis_pl_nas,spis_znak_nas,ixs_spu,ixs_szn,urceni_spis_z,priz_poz_skar,duvod_poz_skar,ixs_zmp_poz_skar,dat_poz_skar) V2:() K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmSpisovyZnakDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamAdmSpisovyZnakDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - spis_pl */
            public spis_pl: string;
            /** PK - spis_znak */
            public spis_znak: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmSpisovyZnakListDto>;

        treeview: Gordic.Data.View<Gordic.AdmIsl.Interface.GAdmSpisovyZnakListDto>

        treeProcessor: Gordic.Data.Tree; 

        treegrid: JQuery<HTMLElement>;

        tabmanager: JQuery<HTMLElement>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmSpisovyZnakDesigner>, spis_pl: string,spis_znak: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, spis_pl,spis_znak);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmSpisovyZnakDesigner>, spis_pl: string,spis_znak: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka
            v_filterForm.addRow("jres:32131165").addField("gselectbox", Gordic.Prefabs.Select.admsslsspl(), { //RC 32131165 : Spisov� pl�n
                name: "spis_pl",
                disabled: (spis_pl) ? true : false,
                dropdown: false,
            })

            return v_filterForm;
        } // createFilterForm

        /**
         * Apply action pro filtra�n� formul��
         * @param that content
         * @param ev ud�lost
         * @param ctx filtra�n� hodnoty k p�eveden� do filtra�n�ho objektu
         */
        static applyAction(that: GContentType<SeznamAdmSpisovyZnakDesigner>, ev, ctx, isReload = false): any {
            var filterObj = {
                spis_pl: SeznamBase.filterContains(ctx.filter, "spis_pl"),
            }
            var data = that.isl.AdmSpisovyZnak.list({ filters: filterObj });
            var activeTab = that.tabmanager.gtabmanager("getActive");
            var reloadTab = activeTab == "tabTree" ? ((isReload == true) ? "tabList" : "tabTree") : ((isReload == true) ? "tabTree" : "tabList"); 
            if (reloadTab == "tabTree") {
                that.treeview = new Gordic.Isl.View(data, {
                    key: "spis_znak",
                    processors: { tree: that.treeProcessor }
                })
                that.treegrid.ggrid("setData", that.treeview);
            } else {
                that.view = new Gordic.Isl.View(data);
                that.grid.ggrid("setData", that.view);
            }
        }

        /**
         * SeznamAdmSpisovyZnakDesignerInit
         * 
         * @param {GContentType<SeznamAdmSpisovyZnakDesigner>} that
         */
        static SeznamAdmSpisovyZnakDesignerInit(that: GContentType<SeznamAdmSpisovyZnakDesigner>, spis_pl: string,spis_znak: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, spis_pl,spis_znak);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            that.treeProcessor = new Gordic.Data.Tree(Gordic.Data.Tree.parentIdOrganizer("spis_znak_nad"), { defaultState: "open" })

            var filterObj: any = {}
            if (spis_pl) {
                new Gordic.Data.Readers.AdmSslsspl().getData({ spis_pl: spis_pl }).done((o) => {
                    that.filter.findFields("spis_pl").gfield("setValue", o[0]);
                })
                filterObj.spis_pl = spis_pl;
            }
            var data = that.isl.AdmSpisovyZnak.list({ filters: filterObj });
            that.view = new Gordic.Isl.View(data, { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
            that.treeview = new Gordic.Isl.View(data, {
                key: "spis_znak",
                processors: { tree: that.treeProcessor }
            })
            console.log(that.treeview);

        } // SeznamAdmSpisovyZnakDesignerInit

    }
}
